import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

interface AutonomousSectionProps {
  value: any;
  onChange: (value: any) => void;
}

export const AutonomousSection: React.FC<AutonomousSectionProps> = ({ value, onChange }) => {
  const [expanded, setExpanded] = useState(true);

  const increment = (field: string) => {
    onChange({ ...value, [field]: (value[field] || 0) + 1 });
  };

  const decrement = (field: string) => {
    onChange({ ...value, [field]: Math.max(0, (value[field] || 0) - 1) });
  };

  return (
    <motion.div className="glass p-6 mb-4" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 20 }}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between mb-4"
      >
        <h2 className="subsection-title mb-0">Autonomous Period</h2>
        <ChevronDown className={`w-5 h-5 transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <>
          <div className="mb-4">
            <label className="form-label">Auto Mobility</label>
            <button
              type="button"
              onClick={() => onChange({ ...value, auto_mobility: !value.auto_mobility })}
              className={`w-full py-2 rounded-lg font-medium transition-all ${
                value.auto_mobility ? 'bg-green-600/30 border border-green-500/50 text-green-300' :
                'bg-gray-700/30 border border-gray-600/50 text-gray-400'
              }`}
            >
              {value.auto_mobility ? '✓ Robot Moved' : '✗ No Mobility'}
            </button>
          </div>

          <div className="mb-4">
            <label className="form-label">Auto Fuel Scored</label>
            <div className="flex items-center gap-4">
              <motion.button
                type="button"
                onClick={() => decrement('auto_fuel_scored')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-secondary btn-touch text-xl"
              >
                −
              </motion.button>
              <span className="text-2xl font-bold text-center flex-1">{value.auto_fuel_scored}</span>
              <motion.button
                type="button"
                onClick={() => increment('auto_fuel_scored')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-primary btn-touch text-xl"
              >
                +
              </motion.button>
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label">Tower Level</label>
            <select value={value.auto_tower_level} onChange={(e) => onChange({ ...value, auto_tower_level: e.target.value })} className="form-input">
              <option value="None">None</option>
              <option value="Level 1">Level 1 (15 pts)</option>
            </select>
          </div>

          <div>
            <label className="form-label">Missed Attempts</label>
            <div className="flex items-center gap-4">
              <motion.button
                type="button"
                onClick={() => decrement('auto_missed_attempts')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-secondary btn-touch text-xl"
              >
                −
              </motion.button>
              <span className="text-2xl font-bold text-center flex-1">{value.auto_missed_attempts}</span>
              <motion.button
                type="button"
                onClick={() => increment('auto_missed_attempts')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-primary btn-touch text-xl"
              >
                +
              </motion.button>
            </div>
          </div>
        </>
      )}
    </motion.div>
  );
};
